/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const HandoffOptions = {
    DELIVERY: 'DELIVERY',
    PICKUP: 'PICKUP',
    DIGITAL: 'DIGITAL'
} as const;
export type HandoffOptions = typeof HandoffOptions[keyof typeof HandoffOptions];


export function instanceOfHandoffOptions(value: any): boolean {
    for (const key in HandoffOptions) {
        if (Object.prototype.hasOwnProperty.call(HandoffOptions, key)) {
            if (HandoffOptions[key as keyof typeof HandoffOptions] === value) {
                return true;
            }
        }
    }
    return false;
}

export function HandoffOptionsFromJSON(json: any): HandoffOptions {
    return HandoffOptionsFromJSONTyped(json, false);
}

export function HandoffOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HandoffOptions {
    return json as HandoffOptions;
}

export function HandoffOptionsToJSON(value?: HandoffOptions | null): any {
    return value as any;
}

export function HandoffOptionsToJSONTyped(value: any, ignoreDiscriminator: boolean): HandoffOptions {
    return value as HandoffOptions;
}

